<template>
  <TextCell v-bind="$props" v-on="$listeners">
    <template #pre>
      <div class="cell-id_container">
        <div class="cell-id_index">{{ index }}</div>
        <Button class="cell-id_actions" type="func" icon="more-horizontal" @click="openOptions" />
      </div>
    </template>
    <template #after>
      <Button
        v-if="groupHasRows"
        type="func"
        icon="chevron-down"
        :reverse-icon="groupClosed"
        @click="$emit('toggle')"
      />
    </template>
  </TextCell>
</template>

<script>
  import TextCell from '@/components/common/TextCell';
  import addSpaces from '@/utils/formatting/add-spaces';
  import { mapState } from 'vuex';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'GroupCell',
    components: {
      TextCell,
      Button,
    },
    extends: TextCell,
    props: {
      totalPrice: [String, Number],
      currency: {
        type: String,
        default: null,
      },
      index: {
        type: [String, Number],
        default: null,
      },
      groupClosed: {
        type: Boolean,
        default: false,
      },
      groupHasRows: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapState('global', ['currencySymbols']),
    },
    methods: {
      addSpaces,
      openOptions(e) {
        this.$emit('options', e);
      },
    },
  };
</script>

<style lang="scss">
  .total-price {
    display: flex;
    color: #1b2d3f;
    font-size: 14px;
    font-weight: 400;
  }

  .comment-price {
    right: 12px !important;
    top: 12px !important;
    margin-top: 0 !important;
  }

  .currency {
    margin-right: 3px;
  }
</style>
